import { useState, useRef, useCallback } from "react";

export default function ImageCompare({ before, after, className = "" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  }, []);

  const onDown = (e) => { dragging.current = true; update((e.touches?.[0] || e).clientX); };
  const onMove = (e) => { if (dragging.current) update((e.touches?.[0] || e).clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={ref}
      data-testid="image-compare"
      className={`relative select-none overflow-hidden rounded-md bg-black ${className}`}
      onMouseMove={onMove} onMouseUp={onUp} onMouseLeave={onUp}
      onTouchMove={onMove} onTouchEnd={onUp}
    >
      <img src={after} alt="after" className="block w-full" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="before" className="block h-full max-w-none" draggable={false}
          style={{ width: ref.current ? ref.current.getBoundingClientRect().width : "100%" }} />
      </div>
      <div className="absolute top-2 left-2 text-[10px] font-mono px-1.5 py-0.5 rounded bg-black/70 text-zinc-300">BEFORE</div>
      <div className="absolute top-2 right-2 text-[10px] font-mono px-1.5 py-0.5 rounded bg-[#faff69]/90 text-black">AFTER ×</div>
      <div className="absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -translate-x-1/2 w-0.5 bg-[#faff69]" />
        <button
          data-testid="compare-handle"
          onMouseDown={onDown} onTouchStart={onDown}
          className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 h-8 w-8 rounded-full bg-[#faff69] grid place-items-center cursor-ew-resize shadow-lg"
        >
          <span className="text-black text-xs font-bold">⇔</span>
        </button>
      </div>
    </div>
  );
}
